export const FINANCE_WORKSPACES = {
  overview: { path: '/finance', label: 'Overview' },
  receivables: { path: '/finance/receivables', label: 'Receivables' },
  payables: { path: '/finance/payables', label: 'Payables' },
  treasury: { path: '/finance/treasury', label: 'Treasury' },
  assets: { path: '/finance/assets', label: 'Assets' },
  budgets: { path: '/finance/budgets', label: 'Budgets' },
  tax: { path: '/finance/tax', label: 'Tax' },
  reports: { path: '/finance/reports', label: 'Reports' },
  administration: { path: '/finance/control', label: 'Administration' },
} as const;
